<script setup>
import { ref } from 'vue'
import {
  IconCopy,
  IconPhoneOutgoing,
  IconDeviceMobileMessage,
  IconBrandWhatsapp
} from '@tabler/icons-vue'

const props = defineProps({
  phoneNumber: {
    type: String,
    required: true
  },
  isVisible: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['close'])

const copyNumber = async () => {
  try {
    await navigator.clipboard.writeText(props.phoneNumber)
    emit('close')
  } catch (err) {
    console.error('Failed to copy:', err)
  }
}

const makeCall = () => {
  window.location.href = `tel:${props.phoneNumber}`
  emit('close')
}

const sendSMS = () => {
  window.location.href = `sms:${props.phoneNumber}`
  emit('close')
}

const openWhatsApp = () => {
  window.location.href = `https://wa.me/${props.phoneNumber.replace(/\D/g, '')}`
  emit('close')
}
</script>

<template>
  <Teleport to="body">
    <!-- Overlay -->
    <div v-if="isVisible"
         class="offcanvas-backdrop show"
         @click="emit('close')">
    </div>

    <!-- Bottom sheet -->
    <div v-if="isVisible"
         class="offcanvas offcanvas-bottom show"
         tabindex="-1"
         @click.stop>
      <div class="offcanvas-header">
        <h5 class="offcanvas-title w-100 text-center">{{ phoneNumber }}</h5>
      </div>
      <div class="offcanvas-body">
        <div class="row g-2">
          <!-- Copy -->
          <div class="col-3">
            <button class="btn btn-outline-primary w-100 h-100 d-flex flex-column align-items-center justify-content-center p-3"
                    @click="copyNumber">
              <IconCopy class="icon" />
              <span class="mt-2">{{ __DICT__.copy }}</span>
            </button>
          </div>

          <!-- Call -->
          <div class="col-3">
            <button class="btn btn-outline-primary w-100 h-100 d-flex flex-column align-items-center justify-content-center p-3"
                    @click="makeCall">
              <IconPhoneOutgoing class="icon" />
              <span class="mt-2">{{ __DICT__.phoneActions.call }}</span>
            </button>
          </div>

          <!-- SMS -->
          <div class="col-3">
            <button class="btn btn-outline-primary w-100 h-100 d-flex flex-column align-items-center justify-content-center p-3"
                    @click="sendSMS">
              <IconDeviceMobileMessage class="icon" />
              <span class="mt-2">{{ __DICT__.phoneActions.message }}</span>
            </button>
          </div>

          <!-- WhatsApp -->
          <div class="col-3">
            <button class="btn btn-outline-primary w-100 h-100 d-flex flex-column align-items-center justify-content-center p-3"
                    @click="openWhatsApp">
              <IconBrandWhatsapp class="icon" />
              <span class="mt-2">{{ __DICT__.phoneActions.whatsApp }}</span>
            </button>
          </div>
        </div>

        <!-- Cancel button -->
        <div class="mt-3">
          <button class="btn btn-ghost-secondary w-100"
                  @click="emit('close')">
            {{ __DICT__.cancel }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<style scoped>
.offcanvas-bottom {
  height: auto;
  z-index: 1090;
}

.icon {
  width: 24px;
  height: 24px;
}

/* Ensure the backdrop covers the full screen and appears above modals */
.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1085;
}
</style>